import React, { useState } from 'react';
import { 
  // Medical & Healthcare
  Heart, Brain, Pill, Stethoscope, Activity, Droplet, Eye, Ear,
  // Body Systems & Organs
  Bone, Skull, Zap, Wind, Waves, CircleDot, Target, Focus,
  // Vital Signs & Health
  Thermometer, HeartPulse, Gauge, TrendingUp, TrendingDown,
  // Medical Equipment
  Syringe, Microscope, TestTube, FlaskConical, Binary, Dna,
  // General Medical
  Plus, Cross, Shield, AlertCircle, CheckCircle, XCircle,
  // Wellness & Care
  Sparkles, Star, Award, Trophy, Gem, Crown,
  // Analysis & Diagnosis
  Search, ScanLine, Timer, Clock, Calendar,
  // Treatment & Care
  Bandage, Lightbulb, Flame, Sunrise, Moon, Sun,
  // Body Parts
  Hand, Fingerprint, Footprints, User, Users, Baby,
  // Respiratory
  CloudRain, Cloud, Cloudy, Tornado,
  // Circulatory
  Droplets, CircleDashed, Circle, Disc, Radio, Radar,
  // Nervous System
  GitBranch, Network, Share2, GitMerge, Workflow, Bolt,
  // Digestive
  Sandwich, Apple, Cherry, Soup, Coffee, Milk,
  // Immune System
  ShieldCheck, ShieldAlert, ShieldPlus, Bug, Siren,
  // Endocrine
  Hexagon, Pentagon, Triangle, Square, Diamond,
  // Muscular
  Dumbbell, FlameKindling, Sparkle,
  // Skeletal
  Frame, Grid3x3, Rows, Columns, Layout,
  // Sensory
  Smile, Frown,
  // Cellular
  Atom, Shapes, Boxes, Grid, Package, Layers,
  // General Health
  HeartHandshake, Hospital, Ambulance, Bed, Building
} from 'lucide-react';

const ICONS = [
  // Primary Medical Icons
  { name: 'Heart', icon: Heart, label: 'Heart', category: 'organs' },
  { name: 'Brain', icon: Brain, label: 'Brain', category: 'organs' },
  { name: 'Bone', icon: Bone, label: 'Bone', category: 'skeletal' },
  { name: 'Skull', icon: Skull, label: 'Skull', category: 'skeletal' },
  { name: 'Eye', icon: Eye, label: 'Eye', category: 'sensory' },
  { name: 'Ear', icon: Ear, label: 'Ear', category: 'sensory' },
  { name: 'Hand', icon: Hand, label: 'Hand', category: 'body' },
  { name: 'Footprints', icon: Footprints, label: 'Feet', category: 'body' },
  
  // Vital Signs & Monitoring
  { name: 'Activity', icon: Activity, label: 'Activity', category: 'vital' },
  { name: 'HeartPulse', icon: HeartPulse, label: 'Heart Rate', category: 'vital' },
  { name: 'Thermometer', icon: Thermometer, label: 'Temperature', category: 'vital' },
  { name: 'Gauge', icon: Gauge, label: 'Pressure', category: 'vital' },
  { name: 'TrendingUp', icon: TrendingUp, label: 'Improving', category: 'vital' },
  { name: 'TrendingDown', icon: TrendingDown, label: 'Declining', category: 'vital' },
  { name: 'Timer', icon: Timer, label: 'Timer', category: 'vital' },
  { name: 'Activity2', icon: Activity, label: 'Pulse', category: 'vital' },
  
  // Medical Equipment & Tools
  { name: 'Stethoscope', icon: Stethoscope, label: 'Stethoscope', category: 'equipment' },
  { name: 'Syringe', icon: Syringe, label: 'Syringe', category: 'equipment' },
  { name: 'Microscope', icon: Microscope, label: 'Microscope', category: 'equipment' },
  { name: 'TestTube', icon: TestTube, label: 'Test Tube', category: 'equipment' },
  { name: 'FlaskConical', icon: FlaskConical, label: 'Flask', category: 'equipment' },
  { name: 'Pill', icon: Pill, label: 'Medication', category: 'equipment' },
  { name: 'Bandage', icon: Bandage, label: 'Bandage', category: 'equipment' },
  { name: 'ScanLine', icon: ScanLine, label: 'Scanner', category: 'equipment' },
  
  // Cellular & Molecular
  { name: 'Dna', icon: Dna, label: 'DNA', category: 'cellular' },
  { name: 'Atom', icon: Atom, label: 'Atom', category: 'cellular' },
  { name: 'Binary', icon: Binary, label: 'Cell', category: 'cellular' },
  { name: 'Shapes', icon: Shapes, label: 'Molecules', category: 'cellular' },
  { name: 'Boxes', icon: Boxes, label: 'Cells', category: 'cellular' },
  { name: 'Layers', icon: Layers, label: 'Tissue', category: 'cellular' },
  { name: 'Grid', icon: Grid, label: 'Cell Structure', category: 'cellular' },
  { name: 'Package', icon: Package, label: 'Organelle', category: 'cellular' },
  
  // Circulatory System
  { name: 'Droplet', icon: Droplet, label: 'Blood', category: 'circulatory' },
  { name: 'Droplets', icon: Droplets, label: 'Blood Flow', category: 'circulatory' },
  { name: 'CircleDot', icon: CircleDot, label: 'Blood Cell', category: 'circulatory' },
  { name: 'CircleDashed', icon: CircleDashed, label: 'Vessel', category: 'circulatory' },
  { name: 'Circle', icon: Circle, label: 'Circulation', category: 'circulatory' },
  { name: 'Disc', icon: Disc, label: 'Platelet', category: 'circulatory' },
  { name: 'Radio', icon: Radio, label: 'Signal', category: 'circulatory' },
  { name: 'Radar', icon: Radar, label: 'Scan', category: 'circulatory' },
  
  // Respiratory System
  { name: 'Wind', icon: Wind, label: 'Breathing', category: 'respiratory' },
  { name: 'Wind2', icon: Wind, label: 'Air', category: 'respiratory' },
  { name: 'Cloud', icon: Cloud, label: 'Lung', category: 'respiratory' },
  { name: 'Cloudy', icon: Cloudy, label: 'Airways', category: 'respiratory' },
  { name: 'CloudRain', icon: CloudRain, label: 'Mucus', category: 'respiratory' },
  { name: 'Tornado', icon: Tornado, label: 'Airflow', category: 'respiratory' },
  { name: 'Waves2', icon: Waves, label: 'Lungs', category: 'respiratory' },
  { name: 'Waves', icon: Waves, label: 'Breathing', category: 'respiratory' },
  
  // Nervous System
  { name: 'Zap', icon: Zap, label: 'Nerve Signal', category: 'nervous' },
  { name: 'Bolt', icon: Bolt, label: 'Impulse', category: 'nervous' },
  { name: 'GitBranch', icon: GitBranch, label: 'Nerve', category: 'nervous' },
  { name: 'Network', icon: Network, label: 'Neural Network', category: 'nervous' },
  { name: 'Share2', icon: Share2, label: 'Synapse', category: 'nervous' },
  { name: 'GitMerge', icon: GitMerge, label: 'Connection', category: 'nervous' },
  { name: 'Workflow', icon: Workflow, label: 'Pathway', category: 'nervous' },
  { name: 'Binary', icon: Binary, label: 'Neuron', category: 'nervous' },
  
  // Digestive System
  { name: 'Sandwich', icon: Sandwich, label: 'Digestive', category: 'digestive' },
  { name: 'Apple', icon: Apple, label: 'Nutrition', category: 'digestive' },
  { name: 'Cherry', icon: Cherry, label: 'Food', category: 'digestive' },
  { name: 'Soup', icon: Soup, label: 'Stomach', category: 'digestive' },
  { name: 'Coffee', icon: Coffee, label: 'Liquid', category: 'digestive' },
  { name: 'Milk', icon: Milk, label: 'Dairy', category: 'digestive' },
  
  // Immune System
  { name: 'Shield', icon: Shield, label: 'Protection', category: 'immune' },
  { name: 'ShieldCheck', icon: ShieldCheck, label: 'Immunity', category: 'immune' },
  { name: 'ShieldAlert', icon: ShieldAlert, label: 'Warning', category: 'immune' },
  { name: 'ShieldPlus', icon: ShieldPlus, label: 'Defense', category: 'immune' },
  { name: 'Bug', icon: Bug, label: 'Pathogen', category: 'immune' },
  { name: 'AlertCircle', icon: AlertCircle, label: 'Virus', category: 'immune' },
  { name: 'Siren', icon: Siren, label: 'Alert', category: 'immune' },
  { name: 'Cross', icon: Cross, label: 'Medical', category: 'immune' },
  
  // Endocrine System
  { name: 'Hexagon', icon: Hexagon, label: 'Gland', category: 'endocrine' },
  { name: 'Pentagon', icon: Pentagon, label: 'Hormone', category: 'endocrine' },
  { name: 'Triangle', icon: Triangle, label: 'Signal', category: 'endocrine' },
  { name: 'Square', icon: Square, label: 'Receptor', category: 'endocrine' },
  { name: 'Diamond', icon: Diamond, label: 'Compound', category: 'endocrine' },
  { name: 'Star2', icon: Star, label: 'Endocrine', category: 'endocrine' },
  
  // Muscular System
  { name: 'Dumbbell', icon: Dumbbell, label: 'Muscle', category: 'muscular' },
  { name: 'Zap2', icon: Zap, label: 'Strength', category: 'muscular' },
  { name: 'FlameKindling', icon: FlameKindling, label: 'Energy', category: 'muscular' },
  { name: 'Sparkle', icon: Sparkle, label: 'Power', category: 'muscular' },
  { name: 'Flame', icon: Flame, label: 'Metabolism', category: 'muscular' },
  
  // General Medical & Health
  { name: 'Plus', icon: Plus, label: 'Add', category: 'general' },
  { name: 'Cross2', icon: Cross, label: 'Healthcare', category: 'general' },
  { name: 'Hospital', icon: Hospital, label: 'Hospital', category: 'general' },
  { name: 'Ambulance', icon: Ambulance, label: 'Emergency', category: 'general' },
  { name: 'Bed', icon: Bed, label: 'Patient', category: 'general' },
  { name: 'HeartHandshake', icon: HeartHandshake, label: 'Care', category: 'general' },
  { name: 'User', icon: User, label: 'Patient', category: 'general' },
  { name: 'Users', icon: Users, label: 'People', category: 'general' },
  { name: 'Baby', icon: Baby, label: 'Infant', category: 'general' },
  { name: 'Building', icon: Building, label: 'Facility', category: 'general' },
  
  // Status & Indicators
  { name: 'CheckCircle', icon: CheckCircle, label: 'Healthy', category: 'status' },
  { name: 'XCircle', icon: XCircle, label: 'Issue', category: 'status' },
  { name: 'AlertCircle', icon: AlertCircle, label: 'Attention', category: 'status' },
  { name: 'Sparkles', icon: Sparkles, label: 'Optimal', category: 'status' },
  { name: 'Star', icon: Star, label: 'Important', category: 'status' },
  { name: 'Award', icon: Award, label: 'Achievement', category: 'status' },
  { name: 'Trophy', icon: Trophy, label: 'Success', category: 'status' },
  { name: 'Gem', icon: Gem, label: 'Premium', category: 'status' },
  { name: 'Crown', icon: Crown, label: 'Priority', category: 'status' }
];

export default function IconPicker({ selectedIcon, onSelectIcon, showCategories = true }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { value: 'all', label: 'All Icons' },
    { value: 'organs', label: 'Organs' },
    { value: 'skeletal', label: 'Skeletal' },
    { value: 'circulatory', label: 'Circulatory' },
    { value: 'respiratory', label: 'Respiratory' },
    { value: 'nervous', label: 'Nervous' },
    { value: 'digestive', label: 'Digestive' },
    { value: 'immune', label: 'Immune' },
    { value: 'endocrine', label: 'Endocrine' },
    { value: 'muscular', label: 'Muscular' },
    { value: 'cellular', label: 'Cellular' },
    { value: 'vital', label: 'Vital Signs' },
    { value: 'equipment', label: 'Equipment' },
    { value: 'general', label: 'General' },
    { value: 'status', label: 'Status' }
  ];

  const filteredIcons = ICONS.filter(icon => {
    const matchesSearch = !searchQuery.trim() || 
      icon.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
      icon.name.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesCategory = selectedCategory === 'all' || icon.category === selectedCategory;
    
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-semibold text-[#6B4423] mb-2">
          Select Display Icon ({ICONS.length} Healthcare Icons)
        </label>
        
        {/* Search */}
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search icons... (e.g., heart, brain, lung)"
          className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded mb-3 focus:outline-none focus:border-[#6B4423]"
        />
        
        {/* Category Filter */}
        {showCategories && (
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded mb-3 focus:outline-none focus:border-[#6B4423]"
          >
            {categories.map(cat => (
              <option key={cat.value} value={cat.value}>{cat.label}</option>
            ))}
          </select>
        )}
        
        {/* Icon Grid */}
        <div className="grid grid-cols-10 gap-2 max-h-64 overflow-y-auto p-2 border-2 border-[#8B6F47] rounded bg-white">
          {filteredIcons.map(({ name, icon: Icon, label }) => (
            <button
              key={`${name}-${label}`}
              type="button"
              onClick={() => onSelectIcon(name)}
              className={`p-3 rounded border-2 hover:bg-[#F4E4C1] transition-colors ${
                selectedIcon === name
                  ? 'border-[#4D9E7C] bg-[#4D9E7C]/10'
                  : 'border-gray-300'
              }`}
              title={label}
            >
              <Icon className="w-6 h-6 text-[#6B4423] mx-auto" />
            </button>
          ))}
        </div>
        
        {filteredIcons.length === 0 && (
          <p className="text-center text-sm text-[#6B4423] mt-2">
            No icons found. Try a different search or category.
          </p>
        )}
        
        {/* Selected Icon Preview */}
        {selectedIcon && (
          <div className="mt-3 flex items-center gap-2 text-sm text-[#6B4423]">
            <span className="font-semibold">Selected:</span>
            {(() => {
              const selected = ICONS.find(i => i.name === selectedIcon);
              const SelectedIcon = selected?.icon;
              return (
                <div className="flex items-center gap-2 px-3 py-1 bg-[#F4E4C1] rounded border border-[#8B6F47]">
                  {SelectedIcon && <SelectedIcon className="w-4 h-4" />}
                  <span>{selected?.label}</span>
                  <span className="text-xs text-gray-500">({selected?.category})</span>
                </div>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
}

// Export the icons map for rendering selected icons elsewhere
export { ICONS };
